const providers = {
  providerName: 'Provider Name',
  providerAddress: 'Provider Address',
  country: 'Country',
  state: 'State',
  city: 'City',
  zipcode: 'Zip Code',
  phoneNumber: 'Phone Number',
  tags: 'Tags',
  modules: 'Modules',
  defaultLocation: 'Default Location',
  locationName: 'Location Name',
  noOfLocations: 'No. of Locations',
  locationAddress: 'Location Address',
  emailAddress: 'Email Address',
  website: 'Website',
}


export default providers